/* eslint-disable */
import React from 'react';
import { H1 } from 'components/core/Headline';

export default () => (
	<div>
		<H1 size="large">SpareFoot, Inc. Client Terms of Service</H1>

		<p>
			<strong>1. Background</strong>
		</p>
		<p>
			SpareFoot, Inc., a Delaware corporation with offices at 3300 N IH35, Suite 200, Austin, TX 78705
			("<strong>SpareFoot</strong>") is a provider of multiple proprietary services (each, a "<strong>Service</strong>"
			and collectively, the "<strong>Services</strong>"), including but not limited to the SpareFoot AdNetwork Service
			("<strong>AdNetwork</strong>") and the SpareFoot SiteBuilder Service ("<strong>SiteBuilder</strong>"). The
			self-storage facility owner or operator ("<strong>Client</strong>") identified on the Order Form attached or linked
			to these terms desires to obtain, and SpareFoot desires to provide, one or more of the Services pursuant to this
			Agreement with respect to the Facilit(ies) owned or operated by Client, as specified in the Order Form.
			Service-specific terms and conditions identified herein (each, "<strong>Supplemental Terms</strong>") apply to one
			or more of the Services based on Client's activation and use of the specific Service, with SpareFoot's permission.
		</p>
		<p>
			These Terms of Service (together with any Order Form and any applicable Supplemental Terms, the
			"<strong>Agreement</strong>") explain the contractual agreement between SpareFoot and Client with respect to the
			Service(s). This Agreement is made to be effective as of the date accepted by SpareFoot (the "<strong>Effective
			Date
			</strong>") following your electronic acknowledgement or execution of an Order Form and/or these Terms of
			Service.
		</p>
		<p>For purposes of clarity, this Agreement is between SpareFoot and Client and shall not be impacted by a change in (i)
		the status of the authorized representative as a service provider to Client or (ii) the ownership or management of
		any Facility, absent further action by Client. If you have any questions about this Agreement, please call us at
		(512) 705-6208 or email us at support@sparefoot.com.
		</p>

		<p>
			<strong>2. Service(s)</strong>
		</p>
		<p>
			2.1 <em>Provision of Service(s)</em>. Subject to the terms and conditions of this Agreement, including without
			limitation
			payment of the applicable fees, if any, specific to a Service, SpareFoot will provide Client with access to the
			Service(s) as specified in the applicable Supplemental Terms. Client may use the Service(s) solely for its/their
			intended purpose in accordance with this Agreement and any Supplemental Terms.
		</p>
		<p>
			2.2 <em>Access to Service(s)</em>. Client acknowledges that maintenance may be required from time to time and as a
			result the Service(s) may be offline from time to time.
		</p>
		<p>
			2.3 <em>Customer Reviews</em>. In connection with the Service(s), customers of the Facilities may submit reviews of
			the
			Facilities via SpareFoot's website, by survey or otherwise. Client acknowledges SpareFoot's right to publish reviews
			concerning the Facilities and that reviews submitted to SpareFoot and posted on its website reflect the opinions and
			beliefs of the individual reviewers and not of SpareFoot or any of its affiliates, officers, directors or employees.
			SpareFoot is not responsible and assumes no liability for any reviews, or for any loss or damage related to such
			reviews. Neither Client nor any affiliate of any Facility may review the Facilities or any competing facilities.
			SpareFoot will not necessarily delete valid, negative reviews of any Facility or monitor the reviews or related
			responses, though it reserves the right to do so. Client may post one response to each customer review of the
			Facilities, so long as the response does not violate SpareFoot's Review Terms and Conditions, available
			[<a href="//www.sparefoot.com/reviewstoc.html">here</a>]. SpareFoot encourages Client to respond to any negative
			reviews and identify how it intends to rectify the customers'
			concerns. If Client believes a review of a Facility is fraudulent or in violation of SpareFoot's Review Terms and
			Conditions, Client should contact SpareFoot at support@sparefoot.com. If after reviewing the information provided by
			Client regarding the potentially fraudulent review, SpareFoot may, but is not required to, remove the review from
			its website.
		</p>
		<p>
			2.4 <em>Rate and Availability Parity</em>. Client shall give SpareFoot Rate and Availability Parity for the
			Facilities.
			"<strong>Rate Parity</strong>" means the same or better rates, promotions, restrictions and policies, including,
			without limitation, required insurance, security deposits and cancellation policy, for a given Facility, unit type,
			date, and amenity types as are available on the Facility's websites, apps or call centers (including any reservation
			systems), directly at the Facility, with any competitor of SpareFoot (which includes any online or offline
			reservation or booking service or intermediary) and/or with any other (online or offline) third party that is a
			business partner of or in any other way related with or connected to Client or the Facility.
		</p>
		<p>
			"<strong>Availability Parity</strong>" means availability (i.e. units available for booking) that is at least as
			favorable as that provided to any competitor of SpareFoot (which includes any online or offline reservation or
			booking service or intermediary) and/or with any other (online or offline) third party that is a business partner of
			or in any other way related with or connected to Client or the Facility. Failure to comply with Rate and
			Availability Parity may result in suspension of Client's SpareFoot account temporarily or permanently.
		</p>

		<p>
			2.5 <em>Honoring Reservations</em>. Client is responsible for keeping all pricing and promotional information up to
			date on
			the AdNetwork. As such, any reservation made for any unit at any price and with any promotion on the AdNetwork must
			be honored by Client and the Facility. Failure to honor pricing and promotions on an as booked basis, as determined
			by SpareFoot, in its sole discretion, may result in suspension of Client's SpareFoot account temporarily or
			permanently.
		</p>

		<p>
			<strong>3. Client Obligations</strong>
		</p>
		<p>
			3.1 <em>Rights Regarding Site(s)</em>. Client certifies that it owns or has all necessary rights to control the
			website(s), if any, that is/are integrated with or linked with the Service(s) (the "<strong>Client Site(s)</strong>"),
			and that to the extent required and applicable, Client has all rights necessary to integrate the Service(s) with the
			Client Site(s), to administer the Service(s), and to fulfill its obligations under this Agreement.
		</p>
		<p>
			3.2 <em>Bug Reporting</em>. Client shall promptly report to SpareFoot all bugs and errors related to the Service(s)
			of which Client becomes aware.
		</p>
		<p>
			3.3 <em>Integration and Assistance</em>. Client shall provide SpareFoot with all information and assistance as
			reasonably required for SpareFoot to activate and operate the Service(s) for Client pursuant to this Agreement,
			including without limitation information about the size, configuration and other specifications of the units
			available at the applicable Facility and all applicable fees, restrictions and requirements. Client represents and
			warrants that all information that it provides to SpareFoot (whether pursuant to 3.3.1 or 3.3.2 below) will be
			current, true, accurate, supportable and complete.
		</p>
		<p>
			3.3.1 <em>Supported Vendors</em>. If as of the Effective Date or thereafter Client manages its units with a software
			vendor supported by SpareFoot (a "<strong>Supported Vendor</strong>"), Client shall integrate its systems with the
			Service(s) via SpareFoot's integration method and maintain such integration during the term of the Agreement.
			Supported Vendors include but are not limited to SiteLink, CenterShift, Domico, Self Storage Manager, and QuikStor.
			Client shall be responsible for enabling a link ("<strong>Link</strong>") from SpareFoot's Service(s) to Client's
			Supported Vendor database ("<strong>Facility Database(s)</strong>") and for obtaining all the necessary licenses,
			credentials, and authorizations from the Supported Vendor to integrate the Facility Database with SpareFoot's
			Service(s),
			including as may be necessary to allow SpareFoot to access the Facility Database(s) on Client's behalf. In its use
			of the Link and in its relationship with the Supported Vendor, SpareFoot acts as an agent of Client. The Link
			enables Client
			and SpareFoot to maintain accuracy of unit pricing and availability information on SpareFoot websites and, if
			supported by the Supported Vendor, allows SpareFoot to initiate reservations on behalf of prospective Facility
			customers.
			Failure to obtain or maintain the necessary licenses, credentials and authorizations may result in suspension of
			Client's SpareFoot account temporarily or permanently.
		</p>
		<p>
			3.3.2 <em>Manual Integration</em>. If at any time Client does not manage its units with a Supported Vendor, Client
			may manage its Service(s) manually, provided that it provides SpareFoot with the requisite data in a format and
			frequency acceptable to SpareFoot.
		</p>
		<p>
			3.4 <em>Advertising</em>. Client shall comply with all applicable laws and regulations relating to advertising and
			otherwise when using the Service(s).
		</p>


		<p>
			<strong>4. Fees and Payment</strong>
		</p>
		<p>
			4.1 <em>Fees</em>. SpareFoot shall be paid the fees, if any, set forth in any Order Form or Supplemental Terms
			executed or accepted by Client. All fees are non-refundable. All fees are due and payable in U.S. dollars and
			exclusive of applicable sales, excise, or use taxes, which shall be the sole responsibility of Client.
		</p>
		<p>
			4.2 <em>Billing and Payment</em>. Billing mechanics for each Service shall be as detailed in the applicable
			Supplemental Terms. All Clients shall enable ACH payment or another accepted electronic payment method, unless
			otherwise agreed by SpareFoot. Each Client that has enabled electronic payment hereby authorizes SpareFoot to
			automatically draft the applicable amount when it becomes due, and agrees to execute and deliver such authorization
			form(s) as may be requested by SpareFoot or the applicable financial or processing institution from time to time. In
			the event Client has not linked an account for electronic payment, Client shall pay the applicable amount due not
			later than thirty (30) days following the date it becomes payable.
		</p>
		<p>
			4.3 <em>Late Payments</em>. If payment is not made when due, SpareFoot may charge Client a late fee on the unpaid
			balance at the lesser of one-and-a-half percent (1.5%) per month or the maximum lawful rate permitted by applicable
			law, rounded to the next highest whole month and compounded monthly. SpareFoot may also charge Client for all
			expenses of collection. Should Client not pay amounts when due, SpareFoot may (at its discretion and in addition to
			other remedies it may have) suspend or deactivate the Service(s), and any applicable de-activation fees specified in
			the applicable Supplemental Terms shall apply.
		</p>
		<p>
			<strong>5. Proprietary Rights</strong>
		</p>
		<p>
			5.1 <em>Ownership of the Service(s)</em>. SpareFoot shall own all right, title, and interest in and to the
			Service(s), including all modifications, improvements, upgrades, and derivative works related thereto and all
			intellectual property rights therein. Client agrees to assign all right, title, and interest it may have in the
			foregoing to SpareFoot. If Client provides or creates feedback in connection with the Service(s)
			("<strong>Feedback</strong>"), Client hereby assigns and agrees to assign all of its right, title, and interest in
			and to such Feedback to SpareFoot. To the extent that the foregoing assignment is ineffective for whatever reason,
			Client hereby grants and agrees to grant to SpareFoot a non-exclusive, perpetual, irrevocable, royalty free,
			worldwide right and license to use, reproduce, disclose, sub-license, distribute, modify and otherwise exploit such
			Feedback without restriction.
		</p>
		<p>
			5.2 <em>Restrictions</em>. Except as expressly set forth herein, Client shall not, and shall not authorize any third
			party to (i) modify, adapt, reverse engineer, disassemble, de-compile or otherwise derive source code from the
			Service(s); (ii) create derivative works based on the Service(s); (iii) rent, lease, lend, sell, redistribute,
			reproduce or sublicense the Service(s) or any part thereof to any third party without SpareFoot's prior written
			consent, or (iv) use the software that embodies the Service(s) other than as intended and directed by SpareFoot in
			connection with the integration thereof with the Client's system. Client shall not remove, alter, cover or obfuscate
			any
			copyright notices or other proprietary rights notices or proprietary mark placed or embedded by SpareFoot on or in
			the Service(s).
		</p>

		<p>5.3 <em>Data Rights</em></p>

		<p>
			5.3.1 <em>Rights in Client Data</em>. As between SpareFoot and Client, Client shall own all right, title and
			interest in and to any data that SpareFoot accesses from the Facility Database(s) or that Client manually provides
			to SpareFoot as contemplated by Section 3.3 (the "<strong>Client Data</strong>"). Client grants SpareFoot all rights
			or licenses in Client Data necessary for SpareFoot to use such information in connection with the provision of the
			Service(s). Without limitation, Client agrees that SpareFoot shall have the right, on behalf of Client, to view
			facility information, unit pricing and availability information, and to view Tenant roster information pursuant to
			verifying move-ins, including without limitation for the purpose of determining fees owed to SpareFoot. SpareFoot
			has the right to copy unit pricing and inventory information to SpareFoot systems as needed to efficiently provide
			the Service(s) and to distribute this Client Data to other sites, forums, aggregators, or other third parties for
			the purpose of promoting Client facilities either individually or in aggregate, pursuant to providing the agreed
			Service(s) to Client. Finally, Client agrees that SpareFoot may use Client Data to collect, develop, create, extract
			or otherwise generate statistics and other information and to otherwise compile, synthesize and analyze such data ("<strong>Blind
			Data
			</strong>"). Notwithstanding anything in this Agreement to the contrary, to the extent that SpareFoot
			collects or generates Blind Data, such Blind Data will be owned solely by SpareFoot and may be used for any lawful
			business purpose without a duty of accounting to Client, provided that such data is not personally identifiable and
			does not identify the source of such data.
		</p>
		<p>
			5.3.2. <em>Rights in SpareFoot Data</em>. SpareFoot shall own all right, title, and interest in and to any data that
			is collected by SpareFoot from Client or provided by Client or consumers in connection with Client's use of the
			Service ("<strong>Usage Data</strong>").
		</p>
		<p>
			5.3.3 <em>Publicly Available Data</em>. Notwithstanding Section 5.3.1, Client Data that is published to the Internet
			on
			behalf of Client is considered publicly available and not bound by any confidentiality provisions. This includes but
			is not limited to facility information, unit pricing, unit availability, photos, consumer reviews, and consumer
			survey responses that are published to the Internet by Client.
		</p>
		<p>
			<strong>6. Warranty and Limitations of Liability</strong>
		</p>
		<p>
			6.1 <em>Warranty Disclaimer</em>. SERVICE(S) ARE PROVIDED TO CLIENT ON AN "<strong>AS IS</strong>" AND "<strong>AS
			AVAILABLE
			</strong>" BASIS, AND SPAREFOOT DISCLAIMS ALL WARRANTIES, CONDITIONS, OR REPRESENTATIONS (EXPRESS OR
				IMPLIED, ORAL, OR WRITTEN) WITH RESPECT THERETO AND WITH RESPECT TO ANY SUPPORT RELATED THERETO, INCLUDING ANY AND
				ALL WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, NON-INTERFERENCE, ACCURACY OF
				DATA, AND WARRANTIES ARISING FROM A COURSE OF DEALING.
		</p>
		<p>
			6.2 <em>Disclaimer of Consequential Damages</em>. IN NO EVENT WILL SPAREFOOT BE LIABLE TO CLIENT FOR ANY SPECIAL,
			CONSEQUENTIAL, INCIDENTAL OR OTHER DAMAGES, HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, AND WHETHER OR NOT
			SPAREFOOT HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
		</p>
		<p>
			6.3 <em>Maximum Liability</em>. IN NO EVENT SHALL SPAREFOOT'S AGGREGATE LIABILITY ARISING OUT OF OR RELATED TO THIS
			AGREEMENT, THE TERMINATION HEREOF, AND/OR PROVISION OF THE SERVICE EXCEED THE AMOUNTS PAID BY CLIENT TO SPAREFOOT
			FOR THE SPECIFIC SERVICE GIVING RISE TO THE CLAIM DURING THE TWELVE (12) MONTHS PRECEDING THE CLAIM. THIS LIMITATION
			OF LIABILITY IS CUMULATIVE AND NOT PER INCIDENT.
		</p>
		<p>
			6.4 <em>Reasonable Allocation of Risk</em>. The parties understand and agree that the limitations of liability set
			forth in this Section are a reasonable allocation of risk between the parties, and, absent such allocation,
			SpareFoot would not be able to charge the prices it charges for the Service(s). The limitations of liability set
			forth in this Agreement shall apply notwithstanding any failure of essential purpose of any limited remedy provided
			herein.
		</p>
		<p>
			<strong>7. Term of Agreement</strong>
		</p>
		<p>
			7.1 <em>Term</em>. This Agreement will commence on the Effective Date and will continue for until terminated in
			accordance herewith.
		</p>
		<p>
			7.2 <em>Termination</em>.
		</p>
		<p>
			7.2.1 <em>For Convenience</em>. SpareFoot may terminate this Agreement and/or any Supplemental Terms by providing
			written notice at any time. Termination under this Section 7.2.1 shall be effective at the end of the then-current
			month.
		</p>
		<p>
			7.2.2 <em>For Breach</em>. In addition, SpareFoot may terminate this Agreement and/or any Supplemental Terms if
			Client is in breach of any term or condition set forth herein or therein, and such breach is not cured in the ten
			(10) day period following SpareFoot giving notice of such breach.
		</p>
		<p>
			7.3 <em>Survival of Certain Terms</em>. Notwithstanding any termination of this Agreement, the following provisions
			shall survive: Sections 4-6, 7.3, and 8, and any Supplemental Terms identified as provisions that shall survive the
			termination hereof. All other rights, obligations, and licenses set forth herein shall cease upon termination of
			this Agreement for any reason.
		</p>
		<p>
			<strong>8. General Provisions</strong>
		</p>
		<p>
			8.1 <em>Compliance with Laws</em>. Client shall comply with all applicable laws, rules, treaties, and regulations in
			its performance of this Agreement. Client will hold harmless, indemnify and defend SpareFoot from any claim against
			SpareFoot arising from Client's failure to comply with this paragraph.
		</p>
		<p>
			8.2 <em>Governing Law and Jurisdiction</em>. This Agreement shall be governed by and construed under the law of the
			State of Texas, without regard to principles of conflict of laws. The federal and state courts of Travis County,
			Texas shall have exclusive jurisdiction and venue to adjudicate any dispute arising out of this Agreement. Each
			party hereto expressly consents to the personal jurisdiction and venue of such courts.
		</p>
		<p>
			8.3 <em>Notices</em>. Any notice required or permitted by this Agreement will be in writing and will be sent by
			registered or certified mail, return receipt requested, or by reputable overnight courier addressed to the other
			party, or in the case of Client via email, at (i) the address shown at the beginning of this Agreement (in the case
				of SpareFoot), (ii) the address or email address provided to SpareFoot in connection with Client's registration for
				the Service(s), (in the case of Client), or (iii) such other address for which such party gives notice hereunder.
				Such notice will be deemed to have been given when delivered or, if delivery is not accomplished by some fault of
				the addressee, when tendered.
		</p>
		<p>
			8.4 <em>Entire Agreement</em>. This Agreement, including any applicable Order Form, and any applicable Supplemental
			Terms, sets forth the entire agreement and understanding of the parties relating to the subject matter hereof and
			thereof. In the event of a conflict between this Agreement and any such Supplemental Terms, the Supplemental Terms
			shall apply, provided, however, that in the event of a conflict between the Order Form and any such Supplemental
			Terms, the Order Form shall apply, in each case solely with respect to such Service. Any modification of or
			amendment to this Agreement, or any waiver of any rights under this Agreement, will be effective only if set forth
			in writing and signed physically or electronically by authorized employees of both parties, or if accepted
			subsequently by Client via a click to accept mechanism presented by SpareFoot.
		</p>
		<p>
			8.5 <em>Severability</em>. If any provision of this Agreement is held to be invalid by a court of competent
			jurisdiction, then the remaining provisions will nevertheless remain in full force and effect.
		</p>
		<p>
			8.6 <em>No Waiver</em>. The failure of either party to enforce at any time any of the provisions of the Agreement,
			or the failure to require at any time performance by the other party of any of the provisions of this Agreement,
			will in no way be construed to be a present or future waiver of such provisions.
		</p>
		<p>
			8.7 <em>Force Majeure</em>. Nonperformance of either party (except for payment obligations) will be excused to the
			extent that performance is rendered impossible by strike, fire, flood, lightning, governmental acts or orders or
			restrictions, failure of suppliers, or any other reason where failure to perform is beyond the reasonable control
			and not caused by the negligence of the non-performing party.
		</p>
		<p>
			8.8 <em>Assignment and Binding Effect</em>. SpareFoot may transfer or assign this Agreement and its rights and/or
			obligations hereunder. Client may not transfer or assign its rights or obligations under this Agreement, including,
			without limitation, in connection with the merger, acquisition or sale of all or substantially all of the assets or
			stock of the business associated with this Agreement, without the prior written consent of SpareFoot, which may be
			withheld by SpareFoot in its sole discretion.
		</p>
		<p>
			8.9 <em>Injunctive Relief</em>. Client agrees that any breach of its obligations regarding Confidential Information
			would result in irreparable injury for which there is no adequate remedy at law. Therefore, in the event of any
			breach or threatened breach of Client's obligations regarding Confidential Information, SpareFoot will be entitled
			to obtain equitable relief in addition to its other available legal remedies in a court of competent jurisdiction,
			without the necessity of proving actual damages or posting bond.
		</p>
		<p>
			<strong>Exhibit A: SpareFoot AdNetwork Supplemental Terms</strong>
		</p>
		<p>
			<strong>A1. Effectiveness of Terms</strong>
		</p>
		<p>
			These Supplemental Terms ("<strong>Supplemental Terms</strong>"), together with SpareFoot Terms of Service, explain
			the contractual agreement between SpareFoot and Client with respect to Client's procurement of the SpareFoot
			AdNetwork Service. These Supplemental Terms are effective as of the date of AdNetwork Service activation by
			SpareFoot, based on Client request. SpareFoot reserves the right to deny activation of the Service at its sole
			discretion.
		</p>
		<p>
			<strong>A2. Service</strong>
		</p>
		<ol>
			<li>
				<p>
					SpareFoot will allow consumers to view and reserve vacant units in Client's Facilities via the AdNetwork,
					online and by phone, as applicable.
				</p>
			</li>
			<li>
				<p>
					SpareFoot will allow Client to maintain information about its facilities, other than vacant inventory
					information which is addressed below, via my.sparefoot.com.
				</p>
			</li>
			<li>
				<p>
					SpareFoot will allow Client to maintain vacant inventory information via Client's Supported Vendor, or if no
					software integration is available, via the my.sparefoot.com website. Client will make only vacant units at
					the Facilities visible on the AdNetwork, and shall not list or advertise occupied units as vacant for any
					reason. Failure to comply with the foregoing may result in suspension of Client's SpareFoot account
					temporarily or permanently.
				</p>
			</li>
		</ol>
		<p>
			<strong>A3. Pricing, Billing and Payment Terms</strong>
		</p>
		<p>
			Pricing and payment terms for the AdNetwork Service vary depending upon whether Client has elected the OneTime
			model or the RentPercent model on the Order Form.
		</p>
		<p>
			<em>OneTime Pricing</em>. If the OneTime pricing model is elected on the Order Form, the Client shall also indicate
			a "Minimum
			Bid" on the Order Form for each Facility. The OneTime fee for each unit in that Facility shall be equal to 66% of
			the applicable Minimum Bid for small units, 100% of the Minimum Bid for medium units, 166% of the Minimum Bid for
			large units, and 100% of the Minimum Bid for parking units. A OneTime fee shall accrue for each move-in processed
			via the Service directly, and also for each move-in by a Tenant first identified via the Service to any unit at the
			applicable Client Facility, or any other Client owned or managed Facility (each, a "<strong>Fee-Triggering
			Move-In
			</strong>").
		</p>
		<p>
			<em>RentPercent Pricing</em>. As an alternative to the OneTime Fee pricing model, Client may elect on an Order Form
			to pay to
			SpareFoot a percentage of the Unit Rate (defined below), for the life of the unit rental for each Tenant
			participating in any Fee-Triggering Move-In ("<strong>RentPercent Tenants</strong>"). "<strong>Unit Rate</strong>"
			means the rate applicable to the
			unit at the time of [reservation] or as subsequently specified by Client.
		</p>
		<p>
			<em>Billing Statement, Reconciliation and Payment. </em> On or about the first day of each month, SpareFoot will
			generate and issue a statement of (a) Fee-Triggering
			Move-Ins (in the case of the OneTime model), or (b) new and then-active RentPercent Tenants at any point
			during the previous month, as applicable, for Client review (the "<strong>AdNetwork Fee Statement</strong>"). The
			AdNetwork Fee Statement shall also specify the aggregate RentPercent or OneTime fees due for such month. Client
			agrees and acknowledges that SpareFoot may use Client Data in accordance with Section 5.3.1 for the purpose of
			identifying Fee-Triggering Move-Ins and RentPercent Tenants. Client shall have until the tenth (10th) calendar day
			of the month to edit and reconcile the AdNetwork Fee Statement based on Client's own Tenant records and shall provide
			substantiation for any reduction in the amount specified in the issued AdNetwork Fee Statement upon request. The total
			amount due for each month shall be locked in at 11:59 PM central time on the tenth (10th) day, irrespective of whether
			Client has made edits to the AdNetwork Fee Statement. The applicable amount is payable on the eleventh (11th) day of
			the applicable month, unless delayed at SpareFoot's discretion, and shall be paid in accordance with Section 4.
		</p>
		<p>
			<em>Change to Pricing Model</em>. Client's election to change the pricing model for a particular Facility after the
			Client activates the AdNetwork Service shall be deemed a voluntary deactivation and shall be dealt with as set forth
			in Section A.4. below.
		</p>

		<p><strong>A4. Service Deactivation</strong></p>
		<p>
			SpareFoot reserves the right to deactivate the AdNetwork Service without notice based on late payment, as described
			in Section 4, or if it believes that Client is in violation of the Agreement, including the AdNetwork Supplemental
			Terms. Client can voluntarily deactivate the AdNetwork Service by written request to
			<a href="mailto://support@sparefoot.com">support@sparefoot.com</a>. Client shall allow 30 days following its
			voluntary deactivation for the removal of information from the AdNetwork. SpareFoot shall not be responsible for the
			removal of information from third party sites or services. Upon deactivation of the AdNetwork Service, the Agreement
			shall remain in effect, provided that the AdNetwork Supplemental Terms will cease to be in effect. Client will
			remain liable for OneTime Fees, as applicable, for any Fee-Triggering Move-In resulting from activity occurring
			during the effective period (even if the move-in itself occurs after termination). Further, if Client has elected the
			RentPercent payment model, Client shall be billed and shall pay SpareFoot, in accordance with Section 4 of the Terms
			of Service a buy-out fee equal to two (2) months rent for each RentPercent Tenant active at termination and one (1) months rent for each RentPercent Tenant resulting
			from activity occurring during the effective period (even if the move-in itself occurs after termination).
		</p>

		<p><strong>A5. Client Obligations</strong></p>
		<p>
			Client agrees not to subvert the AdNetwork system in any way, including, without limitation, by publishing direct
			contact information on the AdNetwork or using the AdNetwork in any way that encourages consumers to pursue or occupy
			Client storage units outside of the AdNetwork. The foregoing includes but is not limited to publishing facility
			phone numbers, email addresses, or website addresses in Client Facility descriptions, promotions, or photos. Client
			agrees to certify its compliance with this Agreement upon request.
		</p>

		<p><strong>Supplemental Terms Applicable to the SpareFoot SiteBuilder Service</strong></p>


		<p><strong>B2. Service</strong></p>
		<ol>
			<li>
				<p>
					SpareFoot will build and host a dedicated website for Client's Facilities.
				</p>
			</li>
			<li>
				<p>
					SpareFoot will allow prospective Tenants to view and reserve vacant units in Client's Facilities via the
					dedicated website.
				</p>
			</li>
			<li>
				<p>
					SpareFoot will allow Client to maintain website content, other than vacant inventory information which is
					addressed below, via the my.sparefoot.com website.
				</p>
			</li>
			<li>
				<p>
					SpareFoot will allow Client to maintain vacant inventory information via Client's Supported Vendor, or if no
					software integration is available via the my.sparefoot.com website. Client will make vacant units, and only
					vacant units, at Client's Facilities visible on the website. Client may not list units that are currently
					occupied or otherwise unavailable. Failure to comply with the foregoing may result in suspension of Client's
					SpareFoot account temporarily or permanently.
				</p>
			</li>
		</ol>


		<p><strong>B3. Pricing and Payment Terms</strong></p>

		<table width="100%" cellPadding="2" cellSpacing="0">
			<tbody>
				<tr>
					<td width="14%">Implementation Fee</td>
					<td width="86%">No fee</td>
				</tr>
				<tr>
					<td width="14%">OneTime Fee</td>
					<td width="86%">No fee for reservations or move-ins processed</td>
				</tr>
				<tr>
					<td width="14%">Subscription Fee</td>
					<td width="86%">$75 per month per Facility, billed monthly by SpareFoot, in advance pursuant to Section 4 of the
						Terms of Service
					</td>
				</tr>
			</tbody>
		</table>

		<p><strong>B4. Service Deactivation</strong></p>
		<p>
			SpareFoot reserves the right to deactivate the SiteBuilder Service without notice based on late payment, as
			described in Section 4, or if it believes that Client is in violation of the Agreement or the SiteBuilder
			Supplemental Terms. Client can voluntarily deactivate the SiteBuilder Service by written request to
			<a href="mailto:support@sparefoot.com">support@sparefoot.com</a>. Client shall allow 30 days following its
			voluntary deactivation for the hosted site to be removed. Upon deactivation of the SiteBuilder Service, the
			Agreement shall remain in effect, provided that the SiteBuilder Supplemental Terms will cease to be in effect, and
			Client will remain liable for any amounts due to SpareFoot incurred during the effective period.
		</p>

		<p><strong>Supplemental Terms Applicable to the SpareFoot Insights Service</strong></p>
		<p><strong>C1. Effectiveness of Terms</strong></p>
		<p>
			These Supplemental Terms ( "<strong>Supplemental Terms</strong>"), together with SpareFoot Terms of Service, explain
			the contractual agreement between SpareFoot and Client with respect to Client's procurement of the SpareFoot
			Insights Service. These Supplemental Terms are effective as of the date of Insights Service activation by SpareFoot,
			based on Client request. SpareFoot reserves the right to deny activation of the Service at its sole discretion,
			refunding any advance payment for the Service, if applicable.
		</p>

		<p><strong>C2. Service</strong></p>
		<ol>
			<li>
				SpareFoot will make available to Client via my.sparefoot.com reports on average regional self storage pricing
				specific to each of Client's Facilities where Service is activated.
			</li>
			<li>
				SpareFoot will allow Client to access, view, and download reports for the duration of Service activation.
			</li>
			<li>
				3. SpareFoot reports will consist of historical monthly data accumulated for the duration of Service activation.
			</li>
		</ol>

		<p><strong>C3. Pricing and Payment Terms</strong></p>

		<table width="100%" cellPadding="2" cellSpacing="0">
			<tbody>
				<tr>
					<td width="40%">Setup Fee:</td>
					<td width="60%">Free</td>
				</tr>
				<tr>
					<td width="40%">Subscription Fee:</td>
					<td width="60%">Free</td>
				</tr>
			</tbody>
		</table>

		<p><strong>C4. Service Deactivation</strong></p>
		<p>
			SpareFoot reserves the right to deactivate the Insights Service without notice if it believes that Client is in
			violation of the Agreement or the Insights Supplemental Terms. Client can voluntarily deactivate the Insights
			Service by written request to support@sparefoot.com. Deactivation will occur at the end of the calendar month when
			notice is received. Upon deactivation of the Insights Service, the Agreement will remain in effect, provided that
			the Insights Supplemental Terms will cease to be in effect, and Client will remain liable for any amounts due to
			SpareFoot incurred during the effective period.
		</p>

		<p><strong>C5. No Data Warranty</strong></p>
		<p>
			DATA REPORTS ARE PROVIDED AS-IS, AND SPAREFOOT DOES NOT WARRANT ACCURACY OR SUITABILITY FOR ANY SPECIFIC PURPOSE.
		</p>

		<p><strong>Supplemental Terms Applicable to SpareFoot Local</strong></p>

		<p><strong>D1. Supplemental Terms Applicable to the SpareFoot Local Service</strong></p>
		<p>
			These Supplemental Terms ( "<strong>Supplemental Terms</strong>"), together with SpareFoot Terms of Service, explain
			the contractual agreement between SpareFoot and Client with respect to Client's procurement of the SpareFoot Local
			Service. These Supplemental Terms are effective as of the date of SpareFoot Local Service activation by SpareFoot.
			The SpareFoot Local Service may be activated at SpareFoot's discretion, provided that a) Client is active on the
			SpareFoot AdNetwork Service, and b) prior to activation Client has been notified of their right to opt out of
			activation of the SpareFoot Local Service and has chosen not to opt out.
		</p>

		<p><strong>D2. Service</strong></p>
		<ol>
			<li>
				SpareFoot will publish and manage Client Facility listings on supported local listing directories ( "<strong>Directories</strong>"),
				which refer consumers to specific Client Facilities on the AdNetwork.
			</li>
			<li>
				SpareFoot will provide reservation services to prospective Tenants, as per the AdNetwork Service, A2.
			</li>
			<li>
				Supported Directories include but are not limited to CityGrid, AT&T (phone-based), Marchex, MerchantCircle,
				SuperPages, and Local.com.
			</li>
			<li>
				SpareFoot will pay all fees associated with publication of Client Facilities on Directories, and manage
				Directory relationships on behalf of Client.
			</li>
			<li>
				5. SpareFoot will publish Client Facilities on additional Directories, as they become available.
			</li>
		</ol>

		<p><strong>D3. Pricing and Payment Terms</strong></p>
		<table width="100%" cellPadding="2" cellSpacing="0">
			<tbody>
				<tr>
					<td width="40%">OneTime Fee</td>
					<td width="60%">Move-ins sourced via the SpareFoot Local Service are priced as per the AdNetwork terms, A3.</td>
				</tr>
			</tbody>
		</table>

		<p><strong>D4. Service Deactivation</strong></p>
		<p>
			SpareFoot reserves the right to deactivate the SpareFoot Local Service in conjunction with deactivation of the
			AdNetwork Service, as described in Section A4. In addition, Client can voluntarily deactivate the SpareFoot Local
			Service by written request to <a href="mailto://support@sparefoot.com">support@sparefoot.com</a>. Client shall allow
			up to 14 days following voluntary deactivation for the removal of information from all Directories. Upon
			deactivation of the SpareFoot Local Service, the Agreement shall remain in effect, provided that the SpareFoot Local
			Supplemental Terms will cease to be in effect, and Client will remain liable for any amounts due to SpareFoot
			incurred during the effective period.
		</p>
		<p>
			SpareFoot may, from time to time, remove Client listings from one or more Directories, based on factors including
			but not limited to availability of advertising inventory, cost of inventory, and availability of Directory
			publishing systems to SpareFoot. Client may request removal from specific Directories, without terminating the
			SpareFoot Local Service, by written request to support@sparefoot.com
		</p>

		<p><strong>D5. Data Warranty</strong></p>
		<p>
			SpareFoot does not warrant the accuracy of information on Directories, and Client acknowledges that listing
			information can, from time to time, be replicated, incomplete, or missing, due to the interconnected and sometimes
			unreliable nature of Directory networks. Upon notification by Client of a listing error, SpareFoot will, with the
			applicable Directory, take commercially reasonable efforts to remedy the error within 14 days.
		</p>
	</div>
);
